import { isHousingCooperative, NestedHome } from '@habity/types';
import { HomeDataBuilder } from './data-builder';
import { associationFields } from './association-fields';

export const getAssociationName = (home: NestedHome): string => {
  const { provider_data, provider_type } = home || {};
  if (!provider_data || !provider_type) return '';

  if (isHousingCooperative(provider_data, provider_type)) {
    // @ts-ignore
    const { association } = provider_data || {};
    return association?.name || '';
  }

  return '';
};

export const getAssociationData = (home: NestedHome) => {
  if (!home?.provider_data || !home?.provider_type) return [];

  return new HomeDataBuilder(home).addFields(associationFields).build();
};
